module.exports = __webpack_public_path__ + "static/prato-development-e4243252a6bcaf1c30dd0dcb735807d1.png";